module.exports = __webpack_public_path__ + "static/media/video-upload-placeholder.cd6b97fb.svg";